(() => {
  'use strict';

  if (window.__cuddypupMageworxBogoOffer) return;
  window.__cuddypupMageworxBogoOffer = true;

  const STYLE_ID = 'cuddypup-mageworx-bogo-offer';
  const CSS = `
    /* Remove Mageworx's empty final divider so the summary is one gap below the last item. */
    .BogoOffer__Divider:empty {
      display: none !important;
    }

    /* Match the larger summary treatment used by the volume bundle. */
    .TotalPriceTitle,
    .YouSaveTitle {
      font-size: 14px !important;
      line-height: 18px !important;
      font-weight: 500 !important;
    }

    /* Keep fixed-amount discount badges compact and on one line. */
    .BogoOffer__DiscountLabelPrice {
      display: inline-flex !important;
      align-items: center !important;
      flex: 0 0 auto !important;
      white-space: nowrap !important;
      border-radius: 4px !important;
    }
  `;

  const enhance = (host) => {
    const root = host.shadowRoot;
    if (!root || root.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    root.append(style);
  };

  const enhanceAll = () => {
    document.querySelectorAll('mw-bogo-offer').forEach(enhance);
  };

  enhanceAll();
  new MutationObserver(enhanceAll).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  /* Mageworx attaches the shadow root lazily when the offer nears the viewport. */
  window.setInterval(enhanceAll, 500);
})();
